import store from '@/redux/store/index.js';
import { getTotalCartAmounts } from '../../utils/getTotalCartAmounts.js';
import { orderItemsToBuyAgain } from '../../utils/orderItemsToBuyAgain.js';
import { saveCart } from '@/redux/actions';
import { PATH, getRoute } from '@/utils/routes.js';
import { getStoreType } from '@/utils/getStoreType.js';
import { STORE_CUSTOMIZATION } from '@/utils/constants';
import { isPLPRequiredSystem } from '@/utils/isPLPRequiredSystem.js';
import { TABS_DATA_MAP } from 'src/constants/order.js';

export const handleNavigateReorder = (e, configs) => {
  e.stopPropagation();

  const { orderItems: rawOrderItems, cartItems, userData, storeData, router } = configs;

  const orderItems = orderItemsToBuyAgain(rawOrderItems);
  const items = [...cartItems, ...orderItems];
  const amount_values = getTotalCartAmounts(items);

  const payload = {
    items,
    store_id: storeData?.store_id,
    merchant_id: 1,
    order_type: 2,
    phone: userData?.phone || '',
    status: 1,
    status_message: 'New',
    deliver_to: '',
    address1: '',
    address2: '',
    latitude: 0,
    longitude: 0,
    ...amount_values,
  };

  store.dispatch(saveCart(payload));

  router.push(getRoute(PATH.PRODUCT, storeData.store_info.domain));
};

export const getNoItemInOrderText = (orderListType) => {
  const storeType = getStoreType();
  let storeTypeBasedtext = '';
  switch (storeType) {
    case STORE_CUSTOMIZATION.ORDER_BASED:
      storeTypeBasedtext = 'order';
      break;
    case STORE_CUSTOMIZATION.B2B:
      storeTypeBasedtext = 'request';
      break;
    default:
      storeTypeBasedtext = 'service';
  }
  return `You don't have any ${TABS_DATA_MAP?.[orderListType]?.text?.toLocaleLowerCase?.()} ${storeTypeBasedtext}`;
};

export const shopButtonClick = ({ collections, router, storeData }) => {
  if (collections?.length) {
    router.push(getRoute(PATH.PRODUCT, storeData?.store_info?.domain));
  } else {
    if (isPLPRequiredSystem(storeData?.theme?.theme_class)) {
      if (storeData?.theme?.custom_theme_flag)
        router.push(getRoute(PATH.PRODUCT, storeData?.store_info?.domain));
      else router.push(getRoute(PATH.SHOP, storeData?.store_info?.domain));
    } else {
      router.push(getRoute(PATH.PRODUCT, storeData?.store_info?.domain));
    }
  }
};
